const classEvaluation = {
  path: 'classEvaluation/:myClassId',
  component: resolve => require(['../../../../../components/pages/student_user/comprehensiveEvaluation/classEvaluation'], resolve),
  props: true
}
export default classEvaluation



// WEBPACK FOOTER //
// ./src/router/pages/student_user/comprehensiveEvaluation/classEvaluation/index.js